import { createRoutine } from "redux-saga-routines";

export const addRtmpLinkRoutine = createRoutine('ADD_RTMP_LINK')
